import apiVersion from '../_helpers/api-version';
import axiosInstance from '../_helpers/axiosConfig'

import { authHeader } from '../_helpers/auth-header'
import { store } from '../_helpers/store';
import getApiVersion from '../_helpers/api-version';
import httpStatus from 'http-status';

function encodeQueryData(data) {
  const ret = [];

  for (let d in data) {
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  }

  return ret.join('&');
}

export const userService = {
  me,
  getUser,
  updateUser,
  retrieveUsers,
  resetPassword,
  forgotPassword,
  changePassword,
  updateUserImage,
  updateUserImageById
};

function me(token) {
  return axiosInstance.request({
    url: `${process.env.REACT_APP_API_URL}/${getApiVersion()}/client/me`,
    method: 'GET',
    headers: { 'Authorization': `Bearer ${token}` }
  })
  .then(response => {
    if (response && response.status === httpStatus.OK) {
      return response.data
    }
  })
}

function getUser() {
  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${getApiVersion()}/client/me`,
  })
}

function updateUser(updatedUser) {
  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${getApiVersion()}/client/profile`,
    data: { ...updatedUser }
  }).then((response) => {
    return response.data;
  })
}

function updateUserImage(base64Image) {
  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${getApiVersion()}/client/profile/image`,
    data: { image: base64Image }
  }).then((response) => {
    return response.data;
  })
}

function updateUserImageById(userId, base64Image) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/user/${userId}/profile-image`,
    data: { image: base64Image }
  }).then((response) => {
    return response.data;
  })
}

function retrieveUsers(page = 1, params = {}) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/users?page=${page}&${encodeQueryData(params)}`,
  }).then((response) => {
    return response.data;
  })
}

function resetPassword(token, password) {
  return axiosInstance.request({
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/reset-password`,
    data: { token, password }
  });
}

function forgotPassword(providerId, username) {
  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/forgot-password`,
    data: { providerId, username }
  });
}

function changePassword(currentPassword, password, confirmPassword) {
  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/change-password`,
    data: { currentPassword, password, confirmPassword }
  });
}